import { CostumGaugeChart } from "../Global/CostumGaugeChart"
import { TextWidget } from "./TextWidget"

export const GaugeChartWidget = (props) => {
    return(
        <div style={{display: 'flex', alignItems: 'center', textAlign: 'center', width: 'inherit', height: props.height, justifyContent: 'center'}}>
            <CostumGaugeChart value={props.value} colors={props.colors} nrOfLevels={props.nrOfLevels} arcsLength={props.arcsLength}/>
            <TextWidget
                label={props.label}
                number={props.value}
                unit={props.unit}
                margin='0'
                width='40%'
                />
        </div>
    )
}